import { diffWords } from "diff";

function TextDiff({ oldText, newText }) {
  const parts = diffWords(oldText, newText);
  return (
    <p className="whitespace-pre-wrap">
      {parts.map((part, i) => {
        if (part.added) {
          return (
            <span
              key={i}
              className="bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-300"
            >
              {part.value}
            </span>
          );
        }
        if (part.removed) {
          return (
            <span
              key={i}
              className="bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 line-through"
            >
              {part.value}
            </span>
          );
        }
        return <span key={i}>{part.value}</span>;
      })}
    </p>
  );
}

export default TextDiff;
